import type { StorageService } from '../../../../../types/azureStorage';
import { Checkbox } from '../../../../../components/ui/checkbox';
import { SAS_SERVICE_NAMES } from './sasForm';

/**
 * S7 review D F1: the services an account SAS covers, chosen BEFORE the token is generated (the default is the least
 * the entry point needs — `defaultAccountSasServices`). The value is always emitted in the SDK's order. The shared
 * Checkbox, like the permissions and the ACL editor (C1 N27).
 */
export function SasServiceFields(props: { value: StorageService[]; onChange: (value: StorageService[]) => void }) {
  const toggle = (service: StorageService, on: boolean) => {
    const next = new Set(props.value);
    if (on) next.add(service); else next.delete(service);
    props.onChange(SAS_SERVICE_NAMES.map(([candidate]) => candidate).filter((candidate) => next.has(candidate)));
  };
  return <fieldset className="space-y-1"><legend className="text-sm font-medium">Services</legend>
    <p className="text-xs text-muted-foreground">The token works on the services ticked here.</p>
    <div className="flex flex-wrap gap-3">{SAS_SERVICE_NAMES.map(([service, name]) => <label key={service} className="flex items-center gap-1 text-xs">
      <Checkbox aria-label={`${name} service`} checked={props.value.includes(service)} onCheckedChange={(checked) => toggle(service, checked === true)} data-testid={`sas-service-${service}`} /> {name}
    </label>)}</div>
  </fieldset>;
}
